import "./Accordion.css";

import type { FC } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

import { ArrowRight } from "~/icons";

export type AccordionProps = {
  data: Array<{
    id: ID;
    title: Record<LanguageCode, string>;
    description: Record<LanguageCode, string>;
  }>;
};
/**
 * @deprecated
 */
export const Accordion: FC<AccordionProps> = ({ data }) => {
  const {
    i18n: { language },
  } = useTranslation();
  const [openId, setOpenId] = useState<null | ID>(null);

  const toggleAccordion = (id: ID): void => {
    setOpenId(id === openId ? null : id);
  };

  return (
    <div className="accordion base-section-container">
      {data?.map((item) => (
        <div
          key={item.id}
          className={`accordion-item ${openId === item.id ? "open" : ""}`}
        >
          <div
            onClick={() => toggleAccordion(item.id)}
            className="accordion-question"
          >
            <h5 className="accordion-title">{item.title[language]}</h5>
            <ArrowRight
              viewBox="0 0 24 24"
              className={`accordion-icon ${openId === item.id ? "rotated" : ""}`}
            />
          </div>
          <ReactMarkdown className="accordion-description">
            {item.description[language]}
          </ReactMarkdown>
        </div>
      ))}
    </div>
  );
};
